<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template #activator="{ on }">
        <v-icon
          small
          color="#140C22"
          v-on="on"
        >
          mdi-help-circle
        </v-icon>
      </template>

      <div class="dialog">
        <v-layout
          row
          align-center
        >
          <v-spacer />
          <v-btn
            icon
            small
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-layout>
        <slot />
      </div>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
<style lang="scss" scoped>
 .dialog {
   background: #FFFFFF;
 }
</style>
